import React from 'react'
import {
  TextField
} from '@material-ui/core';

const Text = ({text, handleChange}) => {
  return (
    <TextField  label="Text"
      variant="outlined"
      name={'text'}
      multiline
      fullWidth
      margin={'normal'}
      value={text}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default Text
